export const api_url = process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL
    : 'http://localhost:4000/';
export const recaptcha_token = process.env.REACT_APP_RECAPTCHA_TOKEN;
// BOA (agents CAF) et BOP (partenaires) sont servis par la même app Scalingo,
// sous deux adresses : la plateforme se déduit de l'adresse visitée
// (espoar-bop.cafreunion.re, espoar-bop-staging…). Ailleurs, dont en local,
// REACT_APP_PLATFORM fait foi.
export function plateformeDepuisAdresse(hote, plateformeParDefaut) {
  return /^espoar-bop[.-]/.test(hote || "") ? "BOP" : plateformeParDefaut;
}
export const PLATFORM = plateformeDepuisAdresse(
  typeof window !== "undefined" ? window.location.hostname : "",
  process.env.REACT_APP_PLATFORM
);

// Titre de l'onglet : public/index.html porte celui du BOA, remplacé au démarrage sur le BOP.
export function titreDePlateforme(plateforme) {
  return `Plateforme E-SPOAR - ${plateforme === "BOP" ? "Partenaire" : "Administrateur"}`;
}

// Adresse affichée en pied de la carte de connexion (« Contacter le support »).
// Non définie : le lien est remplacé par une mention neutre.
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || null;

// Chaque ligne d'adresse est limitée à 38 caractères chez MailEva (prestataire courriers) :
// au-delà, le complément d'adresse est tronqué sur les courriers envoyés.
export const ADRESSE_LIGNE_MAX_CARACTERES_COURRIER = 38;
export const ADRESSE_COMPLEMENT_HINT_COURRIER = `Courriers : ${ADRESSE_LIGNE_MAX_CARACTERES_COURRIER} caractères max`;
export const ADRESSE_COMPLEMENT_TROP_LONGUE_MESSAGE = `Au-delà de ${ADRESSE_LIGNE_MAX_CARACTERES_COURRIER} caractères, le complément d'adresse sera tronqué sur les courriers`;
